import { render, staticRenderFns } from "./ShortVideo.vue?vue&type=template&id=9f518442&scoped=true"
import script from "./ShortVideo.vue?vue&type=script&lang=js"
export * from "./ShortVideo.vue?vue&type=script&lang=js"
import style0 from "./ShortVideo.vue?vue&type=style&index=0&id=9f518442&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f518442",
  null
  
)

export default component.exports